import { atom } from 'recoil';
import { RecoilAtomKey } from '../../recoilConstantKey';

const flowObjAtom = atom({
  key: RecoilAtomKey.flowObjKey,
  default: { nodes: [], edges: [] },
});

const botFlowDataAtom = atom({
  key: RecoilAtomKey.botFlowDataKey,
  default: {},
});

const flowValidationAtom = atom({
  key: RecoilAtomKey.flowValidationKey,
  default: {},
});

// const leadFormDataFieldsAtom = atom({
//   key: RecoilAtomKey.leadFormDataFieldsKey,
//   default: [],
// });

const flowsTableStateAtom = atom({
  key: RecoilAtomKey.flowsTableStateKey,
  default: {
    cache: {},
    totalCountCache: {},
    filters: {
      page: 0,
      rowsPerPage: 10,
      search: '',
      sortBy: 'created_at',
      sortOrder: 'desc',
      totalCount: 0,
      organisationId: '',
      selectedOrganisation: null,
      botNumber: '',
      channelObj: null,
    },
    isLoading: false,
  },
});

export { flowObjAtom, flowValidationAtom, botFlowDataAtom, flowsTableStateAtom };
